import { CloudOff, CloudSync } from '@mui/icons-material';
import { Paper, Switch, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';

const IconContainer = styled(Paper)({
  alignItems: 'center',
  borderRadius: '100%',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  width: '100%',
});

type NetworkOverrideSwitchProps = {
  checked: boolean;
  currentlyOnline: boolean;
  onChange: (checked: boolean) => void;
};

export const NetworkOverrideSwitch = forwardRef<HTMLButtonElement, NetworkOverrideSwitchProps>(
  ({ checked, currentlyOnline, onChange }, ref) => {
    return (
      <Tooltip title={checked ? `Auto detect (${currentlyOnline ? 'Online' : 'Offline'})` : 'Offline mode'}>
        <span>
          <Switch
            ref={ref}
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            icon={
              <IconContainer>
                <CloudOff sx={{ color: (theme) => theme.palette.text.secondary }} />
              </IconContainer>
            }
            checkedIcon={
              <IconContainer>
                <CloudSync sx={{ color: (theme) => theme.palette.primary.main }} />
              </IconContainer>
            }
          />
        </span>
      </Tooltip>
    );
  }
);

NetworkOverrideSwitch.displayName = 'NetworkOverrideSwitch';
